import React, { useEffect } from 'react';
import { Icon } from '@gerdau/hefesto';
import { useDispatch } from 'react-redux';
import { SpinnerIcon } from '../../../../../../../components/Commons/SpinnerIcon/styles';
import { ErrorIcon } from '../../../../../../../components/Commons/Tables/DownloadCellContent/styles';
import {
  downloadNFFile,
  loadNFFile
} from '../../../../../../../store/ducks/long-steel-orders/actions';
import {
  IBilledOrderData,
  IDownloadNFEResponse
} from '../../../../../../../store/ducks/long-steel-orders/types';
import { IconWrapper, Link } from './styles';
import { sendTagging } from '../../../../../../../store/ducks/tagging/actions';
import {
  RcaKind,
  sendRcaLogs
} from '../../../../../../../store/ducks/observability/actions';

interface INFEColumnProps {
  item: IBilledOrderData;
  invoiceNumber: string;
}

const NFEColumn: React.FC<INFEColumnProps> = ({ item, invoiceNumber }) => {
  const dispatch = useDispatch();

  const downloadFromUseEffect = () => {
    dispatch(downloadNFFile(item));
    downloadFile(item.nfState.downloadNFEResponse as IDownloadNFEResponse);
  };

  useEffect(() => {
    if (
      !item?.nfState?.alreadyDownloaded &&
      item?.nfState?.downloadNFEResponse
    ) {
      downloadFromUseEffect();
    }
  });

  const downloadNFE = () => {
    if (item.nfState.downloadNFEResponse) {
      downloadFile(item.nfState.downloadNFEResponse);
    } else {
      dispatch(loadNFFile(item));
      dispatch(sendRcaLogs(RcaKind.DownloadItem, 'NFE', item.id));
    }

    dispatch(
      sendTagging({
        screenName: 'LG:MeusPedidos:AcosLongos:PedidosFaturados',
        event: 'click',
        itemName: 'button:baixar_nota_fiscal',
        itemDescription: `meus_pedidos_acosLongos_pedidosFaturados_baixarNotaFiscal`
      })
    );
  };

  const downloadFile = (downloadNFEResponse: IDownloadNFEResponse) => {
    const dataurl = 'data:text/plain;base64,' + downloadNFEResponse.FILE;
    const element = document.createElement('a');
    element.setAttribute('href', dataurl);
    element.setAttribute('download', `NF-${invoiceNumber}.pdf`);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  return (
    <>
      {item?.nfState?.canDownloadNF
        ? !item?.nfState?.loading &&
          !item.nfState.error && (
            <IconWrapper onClick={downloadNFE}>
              <Icon option="Download" variant="primary" size="sm" />
              {invoiceNumber ? (
                <Link>{invoiceNumber}</Link>
              ) : (
                <Link>Baixar</Link>
              )}
            </IconWrapper>
          )
        : invoiceNumber}

      {item?.nfState?.loading && (
        <>
          <SpinnerIcon style={{ margin: '0.125rem' }} />
          Baixando
        </>
      )}

      {item?.nfState?.error && !item?.nfState?.loading && (
        <>
          <ErrorIcon />
          {invoiceNumber && (
            <>
              {invoiceNumber}
              <br />
            </>
          )}
          Tentar novamente
        </>
      )}
    </>
  );
};

export default NFEColumn;
